(function() {
    'use strict';
    angular.module('wamasysApp').config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider.state('reporting-zone-analysis', {
            parent: 'entity', url: '/reporting-agence/analyse-ia',
            data: {
                authorities: ['ROLE_READ_ONLY', 'ROLE_AREA_MANAGEMENT', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.zoneAnalysis.title'
            },
            views: { 'content@': {
                templateUrl: 'app/business/reporting-zone-analysis/reporting-zone-analysis.html',
                controller: 'ReportingZoneAnalysisController', controllerAs: 'vm'
            } },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, loader) {
                    loader.addPart('zoneAnalysis'); loader.addPart('global'); return $translate.refresh();
                }]
            }
        });
    }
})();
